import styled from '@emotion/styled';
import {
    isDesktopOrTablet,
    isSmallMobile,
    Label,
    Link,
    Paragraph,
    rem,
    isMobile
} from '@triumph/design-system';
import { BreakpointProps } from '../features/common/common.types';

export const FlexDiv = styled.div`
    display: flex;
`;

export const FlexColumnDiv = styled(FlexDiv)`
    flex-direction: column;
`;

export const RightColumn = styled.div<BreakpointProps>`
    display: flex;
    flex: 1;
    flex-direction: ${({ breakpoint }) => isMobile(breakpoint) ? 'column' : 'row'};
    ${({ breakpoint }) => !isMobile(breakpoint) && `width: ${rem(360)};`}
    ${({ breakpoint }) => !isMobile(breakpoint) && `max-width: ${rem(360)};`}
`;

export const FlexRowDiv = styled(FlexDiv)`
    flex-direction: row;
`;

export const FlexItemCenterDiv = styled.div`
    align-self: center;
`;

export const FormSectionFlex = styled.div<BreakpointProps>`
    display: flex;
    gap: ${({ breakpoint }) => (isSmallMobile(breakpoint) ? rem(24) : rem(36))};
    flex-direction: ${({ breakpoint }) =>
        isSmallMobile(breakpoint) ? 'column' : 'row'};
    padding-bottom: ${({ breakpoint }) =>
        isSmallMobile(breakpoint) ? rem(24) : rem(32)};
    justify-content: center;
    flex-wrap: wrap;
`;

export const SplitFormSection = styled(FormSectionFlex)`
    justify-content: space-between;
    flex: 1;
    padding: 0;
    width: 100%;
    gap: ${({ breakpoint }) => (isSmallMobile(breakpoint) ? rem(24) : rem(36))}
        0;
    > div {
        ${({ breakpoint }) =>
            isDesktopOrTablet(breakpoint)
                ? `
            max-width: 48%;
        `
                : ``}
    }
`;

export const FormColumnLeftFlexItem = styled.div<BreakpointProps>`
    width: ${({ breakpoint }) => (isSmallMobile(breakpoint) ? `100%` : `50%`)};
    padding: ${({ breakpoint }) =>
        isSmallMobile(breakpoint)
            ? `0 0 ${rem(18)} 0`
            : `0 ${rem(18)} ${rem(36)} 0`};
`;

export const DividerCell = styled(FlexColumnDiv)`
    padding: ${rem(16)} 0;
    border-bottom: ${({ theme }: any) =>
        `${rem(1)} solid ${theme.colors.greyscale.gray5}`};
`;

export const DetailText = styled(Label)<{ fontSize?: number }>`
    color: ${rem(1)} ${({ theme }: any) => theme.colors.greyscale.gray40};
    font-size: ${({ fontSize }: any) => (fontSize ? rem(fontSize) : rem(10))};
    font-weight: ${({ theme }) => {
        return theme.typography.fontWeights.regular;
    }};
    letter-spacing: ${rem(0.8)};
    text-transform: uppercase;
    margin: 0;
`;

export const UnorderedListStyleNone = styled.ul`
    list-style: none;
    padding-left: 0;
    margin: 0;
`;

export const EmphasisContainer = styled.div`
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.greyscale.gray2_5};
    padding: ${rem(10)} ${rem(20)};
`;

export const LinkNoLine = styled(Link)`
    text-decoration: none;
`;

export const TransparentInputField = styled.div`
    input {
        background-color: transparent;
    }
    select {
        background-color: transparent;
    }
    div {
        background-color: transparent;
    }
`;

export const CommonParagraph = styled(Paragraph)`
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
    line-height: ${({ theme }) => theme.typography.lineHeights.body.medium};
    margin: 0;
    max-width: 100%;
`;

export const CommonUl = styled.ul`
    padding-left: ${rem(20)};
    margin: 0;

    & li::marker {
        color: ${({ theme }) => theme.colors.greyscale.gray50};
    }
`;

export const NoMarginLabel = styled(Label)`
    margin: 0;
`

export const NoMarginParagraph = styled(Paragraph)`
    margin: 0;
`